import { render, staticRenderFns } from "./TarotTestList.vue?vue&type=template&id=07435838&scoped=true&"
import script from "./TarotTestList.vue?vue&type=script&lang=js&"
export * from "./TarotTestList.vue?vue&type=script&lang=js&"
import style0 from "./TarotTestList.vue?vue&type=style&index=0&id=07435838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07435838",
  null
  
)

export default component.exports